var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirgainW60XH32WhiteV1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo__x7C__White__x7C__Vector"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.8,16c0,6.2-3,11.6-7.6,15,3.7-3.7,5.9-9.1,5.9-15s-2.3-11.3-5.9-15c4.6,3.4,7.6,8.8,7.6,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,16c0,5.5-2.7,10.4-6.8,13.4,3.3-3.3,5.3-8.1,5.3-13.4s-2-10-5.3-13.4c4.1,3,6.8,7.9,6.8,13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.2,16c0,4.4-2.1,8.4-5.5,10.8,2.6-2.7,4.3-6.5,4.3-10.8s-1.6-8.1-4.3-10.8c3.3,2.4,5.4,6.4,5.4,10.8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirgainW60XH32WhiteV1);
export default __webpack_public_path__ + "static/media/Airgain_W60xH32_white_v1.ba7fb4c9e40f7f1b49ad8a6dc066fa58.svg";
export { ForwardRef as ReactComponent };